import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import {
  HandlePurchaseRequestStatus,
  printData,
} from "../../../utility/CommonFunctions";
import moment from "moment";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import Logs from "../../Logs/Logs";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MainHeading from "../../../components/comman/MainHeading";

export default function GrnDetail() {
  let { id } = useParams();
  const navigate = useNavigate();
  const [dataLoading, setDataLoading] = useState(true);
  const [state, setState] = useState({
    grnData: {},
    siteBudget: [],
    loading: false,
    IncreaseLoading: false,
  });
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    siteList: [],
    searchQuery: "",
    sortByDate: "",
    year: "",
    siteId: "",
    downloadLoading: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [refreshLogs, setRefreshLogs] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modal, setModal] = useState({
    viewDocModal: false,
    approveRejectModal: false,
  });

  const toggle = (type) => {
    printData(type);
    setModal((prevModal) => ({
      ...prevModal,
      viewDocModal:
        type === "view" ? !prevModal.viewDocModal : prevModal.viewDocModal,
      approveRejectModal:
        type === "approveReject"
          ? !prevModal.approveRejectModal
          : prevModal.approveRejectModal,
    }));
  };

  useEffect(() => {
    GetGrnDetail();
  }, []);

  const GetGrnDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_GRN_detail + `grnId=${id}`;
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setState((pre) => ({
          ...pre,
          grnData: response?.data,
        }));
        // printData("PT-Data", response?.data);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    toggle("view");
  };

  const handleReqStatus = (status, reason = "") => {
    setIsLoading(true);

    let postData = {
      status: status,
      ...(status === "Rejected" && { rejectReason: reason }),
    };
    const option = {
      method: "POST",
      data: postData,
    };

    callApi(apiUrl.update_GRN_ststus + `?grnId=${id}`, option)
      .then((res) => {
        setIsLoading(false);
        if (res?.status === true) {
          toast.success(res?.message);
          GetGrnDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
        toggle("approveReject");
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  return (
    <>
      {dataLoading && <BgBlurLoader />}
      {pageStates?.downloadLoading && <BgBlurLoader />}
      <div className="content container-fluid">
        <MainHeading title="GRN Detail" showBackButton={true} />
        <form action="">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <ul
                        className={
                          dataLoading
                            ? "row list-unstyled mt-4 loading-skeleton"
                            : "row list-unstyled mt-4"
                        }
                      >
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              GRN NO. :-
                            </span>
                            {state.grnData?.grnNumber || "--"}
                          </p>
                        </li>

                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              PO NO. :-
                            </span>
                            {state.grnData?.purchase?.purchaseNumber
                              ? state.grnData?.purchase?.purchaseNumber
                              : "--"}
                          </p>
                        </li>

                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Date :-
                            </span>
                            {state.grnData?.date
                              ? moment(state.grnData?.date).format("DD-MM-YYYY")
                              : "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Financial Year :-
                            </span>
                            {state?.grnData?.financialYear || "--"}
                          </p>
                        </li>

                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Created By :-
                            </span>
                            {state?.grnData?.user?.name || "--"}{" "}
                            {state?.grnData?.user?.designation?.name && (
                              <span className="text-muted fs-5">
                                ({state?.grnData?.user?.designation?.name})
                              </span>
                            )}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Site :-
                            </span>
                            {state.grnData?.site?.name
                              ? state.grnData?.site?.name
                              : "--"}
                          </p>
                        </li>

                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Status :-
                            </span>
                            {HandlePurchaseRequestStatus(state.grnData?.status)}
                          </p>
                        </li>
                        {state.grnData?.rejectReason && (
                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Reject Reason :-
                              </span>
                              {state.grnData?.rejectReason}
                            </p>
                          </li>
                        )}
                        {state?.grnData?.rejectReason && (
                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Reject Reason :-
                              </span>
                              {state?.grnData?.rejectReason || "--"}
                            </p>
                          </li>
                        )}
                      </ul>
                    </div>

                    <div className="col-12 ">
                      <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                        <h4 className="fs-3 rajdhani-semibold my-4 ">
                          Item Details
                        </h4>
                      </div>
                      {state?.grnData?.grnheads?.map((exHead, index) => {
                        let totalAmount = 0;
                        let totalAmountWithGST = 0;
                        return (
                          <div key={exHead.id}>
                            <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                              <h4 className="fs-3 rajdhani-semibold my-4 mx-4 text-muted text-decoration-underline">
                                {exHead?.expensehead?.name}
                              </h4>
                            </div>
                            <table className="table mt-3">
                              <thead>
                                <tr>
                                  <th className="text-start">Item</th>
                                  <th className="text-start">HSN Code</th>
                                  <th className="text-start">Quantity</th>
                                </tr>
                              </thead>
                              <tbody>
                                {exHead?.grnitems?.map((item, i) => {
                                  const amount =
                                    parseFloat(item?.quantity) *
                                    parseFloat(item?.rate);
                                  const gstAmount =
                                    (amount * parseFloat(item?.gst)) / 100;

                                  totalAmount += amount;
                                  totalAmountWithGST += gstAmount;
                                  return (
                                    <tr key={i}>
                                      <td className="desc-wrapper text-start">
                                        {item?.item?.name}
                                      </td>
                                      <td className="desc-wrapper text-start">
                                        {item?.item?.hsnCode || "--"}
                                      </td>
                                      <td className="desc-wrapper text-start">
                                        {item?.quantity} {item?.item?.unit}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        {!dataLoading && state?.grnData?.canChangeStatus && (
          <div className="d-flex align-items-center justify-content-end gap-3 mb-3">
            <button
              className="btn btn-danger px-5"
              type="button"
              onClick={() => {
                setModalType("reject");
                toggle("approveReject");
              }}
            >
              Reject
            </button>
            <button
              className="btn btn-success px-5"
              type="button"
              onClick={() => {
                setModalType("approve");
                toggle("approveReject");
              }}
            >
              Approve
            </button>
          </div>
        )}

        <div className="row">
          <div className="col-12 ">
            <div className="card manage-user-list">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                  <h4 className="d-flex align-items-center mb-4">Documents</h4>
                </div>
                <ul className="row list-unstyled gap-3">
                  {state?.grnData?.documents?.length > 0 ? (
                    state?.grnData?.documents?.map((doc, index) => {
                      return (
                        <li className="col-12">
                          <div
                          className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100"
                          onClick={() => handleDocumentClick(doc)}
                          role="button"
                        >
                          <span className="d-flex align-items-center gap-2">
                            <DocumentIcon />
                            {doc?.name || "Document"}
                          </span>
                          <span className="fs-6">
                            {doc?.updatedAt ? moment(doc?.updatedAt).format("DD MMM YYYY | h:mm a") : ""}
                          </span>
                        </div>
                        </li>
                      );
                    })
                  ) : (
                    <div>No Document Found</div>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="form-group mb-3">
            <label htmlFor="totalLeavePerMonth" className="form-label">
              Description
            </label>
            <CKEditor
              editor={ClassicEditor}
              data={state?.grnData?.description || ""}
              disabled={true}
              config={{
                toolbar: [],
                readOnly: true,
                image: {
                  toolbar: [
                    "imageStyle:alignLeft",
                    "imageStyle:alignCenter",
                    "imageStyle:alignRight",
                    "|",
                    "imageTextAlternative",
                  ],
                },
              }}
            />
          </div>
        </div>

        <Logs
          type={"grn"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </div>

      <ApproveRejectModal
        modal={modal.approveRejectModal}
        toggle={() => toggle("approveReject")}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject" ? "Rejected" : "Approved",
            reason
          )
        }
        isLoading={isLoading}
        actionType={modalType}
      />
      <ViewDocumentModal
        modal={modal.viewDocModal}
        toggle={() => toggle("view")}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
